/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

( function() {
    
    gsap.registerPlugin(ScrollTrigger);
        
    if( $('.whatWeOffer-scroll-box').length ){
        gsap.to('.whatWeOffer-scroll-box', {
            scrollTrigger: {
                trigger: '.whatWeOffer',
                start: '-200px center',
                end: 'bottom +400px',
                //markers: true,
                scrub: 2.5,
                //pin: true
            },
            xPercent: 60,
            duration: 3
        });
        gsap.to('.red-circle', {
            scrollTrigger: {
                trigger: '.whatWeOffer',
                start: '-200px center',
                end: 'bottom',
                //markers: true,
                scrub: 2.5,
                //pin: true
            },
            xPercent: 100,
            duration: 3
        });
    }
    if( $('.whatWeOfferItem__scroll').length ){
        
        var sections = gsap.utils.toArray('.whatWeOfferItem__scroll');

        sections.forEach((section) => {
            var _parrent = $(section).parents('.whatWeOfferItem');
            gsap.to(section, {
                scrollTrigger: {
                    trigger: _parrent,
                    start: '-200px center',
                    end: 'bottom +400px',
                    //markers: true,
                    scrub: 2.5,
                    //pin: true
                },
                xPercent: 40,
                duration: 3
          });

        });
    }

    if( $('.platforms-scroll-box').length ){
        gsap.to('.platforms-scroll-box', {
            scrollTrigger: {
                trigger: '.platforms',
                start: '-200px center',
                end: 'bottom +100px',
                //markers: true,
                scrub: 2.5,
                //pin: true
            },
            xPercent: 80,
            duration: 3
        });
    }

    if( $('.serviceSingle-scroll-box').length ){
        gsap.to('.serviceSingle-scroll-box', {
            scrollTrigger: {
                trigger: '.serviceSingle',
                start: '-200px center',
                end: 'bottom center',
                //markers: true,
                scrub: 2.5,
                //pin: true
            },
            xPercent: 60,
            duration: 3
        });
    }

    gsap.to('.rounded-footer-wrap', {
        scrollTrigger: {
            trigger: '.site__footer',
            start: '-300px center',
            end: '+300px center',
            //markers: true,
            scrub: 1.5,
            //pin: true
        },
        height: 0,
        duration: 3
    });
    
} )();